jQuery(document).ready(function ($) {

    // Related blogs slider

    $('.blog__related-posts--slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: false,
        dots: false,
        arrows: true,
        pauseOnHover: true,
        speed: 600,
        cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
        appendArrows: $('.blog__related-posts--controlls'),
        prevArrow: '<button type="button" class="blog__related-posts--arrow blog__related-posts--arrow-prev"><i class="fa-solid fa-arrow-left"></i></button>',
        nextArrow: '<button type="button" class="blog__related-posts--arrow blog__related-posts--arrow-next"><i class="fa-solid fa-arrow-right"></i></button>',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    // Awards slider slider

    $('.awards-accreditations__inner--logos').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        infinite: true,
        dots: false,
        arrows: false,
        pauseOnHover: true,
        speed: 5000,
        cssEase: 'linear',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });

    // Testimonial slider slider

    $('.testimonials__inner--slider').each(function () {
        var $slider = $(this);
        var $controls = $slider.closest('.testimonials__inner').find('.testimonials__inner--controls');

        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            infinite: true,
            dots: false,
            arrows: true,
            pauseOnHover: true,
            speed: 600,
            cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
            appendArrows: $controls,
            prevArrow: '<button type="button" class="testimonials__inner--arrow testimonials__inner--arrow-prev"><i class="fa-solid fa-chevron-left"></i></button>',
            nextArrow: '<button type="button" class="testimonials__inner--arrow testimonials__inner--arrow-next"><i class="fa-solid fa-chevron-right"></i></button>',
        });
    });

    // Team member testimonial slider

    $('.team-members__testimonials--slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        dots: false,
        fade: true,
        cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
        speed: 800
    });

    // Logo carousel

    $('.logo-carousel__inner--carousel').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        infinite: true,
        dots: false,
        arrows: false,
        pauseOnHover: true,
        speed: 5000,
        cssEase: 'linear',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });

    // Image gallery slider

    $('.image-gallery__inner--carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        dots: false,
        arrows: true,
        pauseOnHover: true,
        speed: 600,
        cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
    });

});